import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../App';

const ToastSettingsContext = createContext({
  position: 'bottom-right',
  duration: 4000,
  showCloseButton: true
});

export const ToastSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    position: 'bottom-right',
    duration: 4000,
    showCloseButton: true,
    stackLimit: 3
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await axios.get(`${API}/toast-settings`);
        if (res.data) {
          setSettings({
            position: res.data.position || 'bottom-right',
            duration: res.data.duration || 4000,
            showCloseButton: res.data.show_close_button ?? true,
            stackLimit: res.data.stack_limit || 3
          });
        }
      } catch (error) {
        // Non-critical: silently handled
      }
    };
    fetchSettings();
  }, []);

  return (
    <ToastSettingsContext.Provider value={settings}>
      {children}
    </ToastSettingsContext.Provider>
  );
};

export const useToastSettings = () => useContext(ToastSettingsContext);

export default ToastSettingsContext;
